<div class="ui-wysiwyg" [class.read-only]="readOnly()">
  @if(label()){
  <h2 class="mb-4">{{ label() }}</h2>
  } @let controlValue = control(); @if(controlValue){
  <quill-editor [formControl]="controlValue" [readOnly]="readOnly()" [modules]="modules()">
  </quill-editor>
  }
</div>
